import * as React from "react";
const SvgFiRrCompassSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-compass-slash_svg__a)">
      <path
        fill="#062147"
        d="M8.038 15.69c-.022.04-.076.131.032.24.11.11.201.053.241.032l1.428-.827a.999.999 0 1 1 1.002 1.73l-1.428.827a2.2 2.2 0 0 1-1.109.302c-.564 0-1.12-.222-1.548-.65a2.174 2.174 0 0 1-.349-2.657l.827-1.428a.997.997 0 0 1 1.366-.364.997.997 0 0 1 .364 1.366zm15.67 6.603a.999.999 0 1 1-1.415 1.414l-22-22A.999.999 0 1 1 1.707.293L4.26 2.846A11.94 11.94 0 0 1 12 0c6.617 0 12 5.383 12 12 0 2.853-1.014 5.574-2.846 7.74zM5.677 4.263l4.596 4.597 4.417-2.557a2.17 2.17 0 0 1 2.657.348c.715.715.854 1.783.348 2.658l-2.557 4.416 4.597 4.597A9.96 9.96 0 0 0 22 12c0-5.514-4.486-10-10-10-2.324 0-4.54.803-6.323 2.263m7.998 8 2.29-3.956c.023-.04.077-.133-.03-.24-.11-.11-.203-.056-.242-.033l-3.956 2.29zm2.495 8.828a9.9 9.9 0 0 1-4.17.91C6.485 22 2 17.513 2 12c0-1.427.292-2.803.871-4.09a1 1 0 1 0-1.824-.82A11.9 11.9 0 0 0 0 12c0 6.616 5.383 12 12 12 1.747 0 3.432-.368 5.007-1.092a1 1 0 0 0-.836-1.818"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-compass-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCompassSlash;
